<template>
  <div class="hero-bg">
    <!-- Pattern geometrico sottile per un look professionale -->
    <div class="hero-pattern"></div>
    <!-- Accento luminoso sottile -->
    <div class="hero-accent"></div>
  </div>
</template>

<script>
export default {
  name: 'HeroBackground'
}
</script>

<style lang="scss" scoped>
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  
  .hero-pattern {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.03) 1px, transparent 0);
    background-size: 40px 40px;
  }
  
  .hero-accent {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  }
}
</style>
